import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomModelBlogUrl,
  BackendMutationPerformanceCenterAddCustomModelBlogUrlArgs,
} from 'src/types/backend';

import { FRAGMENT_CUSTOM_MODEL_BLOG_URL } from '../customModel/schema';

const MUTATION = gql`
  mutation performanceCenterAddCustomModelBlogUrl($url: String!, $customerId: ID!) {
    performanceCenterAddCustomModelBlogUrl(url: $url, customerId: $customerId) {
      ...CustomModelBlogUrl
    }
  }
  ${FRAGMENT_CUSTOM_MODEL_BLOG_URL}
`;

type Variables = BackendMutationPerformanceCenterAddCustomModelBlogUrlArgs;
type Result = BackendCustomModelBlogUrl;

export const performanceCenterAddCustomModelBlogUrl = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
